module.exports = __webpack_public_path__ + "static/media/art-studies.f96084e1.png";